
import { IEnv } from "../interface/util";

function _getProcessEnv<T>(envName: string): T|null {
    return (process.env as any)[envName] as T|null
}

function _getWindowEnv<T>(envName: string): T|null {
    if ( window === undefined ) { return null; }
    if ( (window as any).ENV === undefined ) { return null; }
    const envObj = (window as any).ENV as any
    const val =  envObj[envName] as T|null;
    return val; 
}

function getValue<T>(envName: string): T|null {
    const isDev = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development');

    const value: T|null = 
        (isDev && _getProcessEnv<T>(envName)) ||
        _getWindowEnv<T>(envName);

    return value;
}

function getValueWithDefault<T>(envName: string, defaultValue: T): T {
    return getValue<T>(envName) || defaultValue;
}

function getNumber(name: string, defaultValue: number = -1): number {
    return getValue<number>(name) ?? defaultValue;
}

function getBoolean(name: string, defaultValue: boolean = false): boolean {
    return getValue<boolean>(name) ?? defaultValue;
}

function getString(name: string, defaultValue: string = ""): string {
    return getValue<string>(name) ?? defaultValue;
}

const exports: IEnv = {
    getValue,
    getValueWithDefault,
    getNumber,
    getBoolean,
    getString,
}

export default exports;
